import React, { Fragment, useState, useEffect, useRef } from 'react'
import { Card, Modal, Form, Row, Col, Container, Button, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceGetCfgForm } from '../../../../api/api-antecendentes-legales';
import Procesos from './components/procesos';
import { LoadingComponent } from 'recupero-comunes';
import { useFormik } from 'formik'
import { getBase64 } from '../../../../common/Formatos';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../../../common/uploadArchivoGranTamano';
import { validationSchemasCierreGestionDefenza } from '../../../../common/validation-Shemas-cierre-gestion-defenza';
import { serviceCierreGestionDefenza } from '../../../../api/api-cierre-gestion-defenza';
import { serviceObtieneParametro } from '../../../../api/api-parametros';
import { useNavigate } from 'react-router-dom';
import Mensajes from '../../../mensajes'

const CierreGestionDefenzaModal = ({ showCierreGestion, handleClose }) => {
    const fileRef = useRef();
    const history = useNavigate()
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const queryState = JSON.parse(localStorage.getItem('filtrosAreaGestion'));
    const { llaves } = data_gestion_defensa;
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);
    const [responseData, setResponseData] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [situacionSelect, setSituacionSelect] = useState("");
    const [totalesPagados, setTotalesPagados] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });
    const [validateSituacion, setValidateSituacion] = useState({ tieneProcesoCerrado: false, todosEstadoCerrado: false, totalLength: 0, tieneProcesoCierreAplicado: false });
    const [loadProcesos, setLoadProcesos] = useState(false);
    const [handleDataSubmit, setHandleDataSubmit] = useState(null);
    const [procesoSeleccionado, setProcesoSeleccionado] = useState(null);
    const [glosaModalInfo, setGlosaModalInfo] = useState("");

    useEffect(() => {
        if (showCierreGestion) getCfgForm();
    }, [showCierreGestion])

    useEffect(() => {
        if (validateSituacion.totalLength === 1 && validateSituacion.tieneProcesoCerrado) {
            setSituacionSelect("conPago");
            formik.setFieldValue('situacion', "conPago");
        }

        if (loadProcesos) {
            if (!validateSituacion.todosEstadoCerrado) handleCloseModal();
            else history('/area-gestion-compania', { state: { queryState } });
        }
    }, [validateSituacion])

    const getCfgForm = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 47 })).toString('base64');
        try {
            const [response, limiteLiviano, limitePesado] = await Promise.all([
                serviceGetCfgForm(query),
                serviceObtieneParametro(52),
                serviceObtieneParametro(53),
            ]);
            setCfg_form(response);
            setLimites({ liviano: limiteLiviano, pesado: limitePesado });
        } finally {
            setLoading(false);
        }
    }

    const handleFileChange = (e) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            formik.setFieldValue("file", file);
        }
    }

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        if (fileRef.current) fileRef.current.value = "";
        setShowConfirmGrande(false);
    }

    const handleConfirmArchivoGrande = () => {
        formik.setFieldValue("file", pendingFile);
        setShowConfirmGrande(false);
    }

    const handleCloseModal = () => {
        handleClose();
        formik.resetForm();
        if (fileRef.current) fileRef.current.value = ""
        setSituacionSelect("");
        setLoadProcesos(false);
        setProcesoSeleccionado(null);
        archivoSubidoRef.current = { file: null, s3Bucket: null, s3Key: null };
    }

    const handleCloseToast = () => {
        setShowToast(false);
        setLoadProcesos(false);
        if (responseData?.code === 1) { setLoadProcesos(true); }
    }
    const handleShowModalInfo = (info) => {
        let glosaModal = "Cuando Situación de Terminado es Con Pago, al menos un implicado debe tener pago ingresado.";
        if (info == 1) {
            glosaModal = "Debe seleccionar Proceso Judicial.";
        }
        setGlosaModalInfo(glosaModal);
        setShowModalInfo(true)
    }
    const cierreGestionDefenza = async (dataSubmit) => {
        const data = showModalConfirm ? handleDataSubmit : dataSubmit;
        setLoading(true);
        setShowModalConfirm(false);

        const response = await serviceCierreGestionDefenza(data);
        setLoading(false);
        setResponseData(response);
        setShowToast(true);
    }

    const formik = useFormik({
        initialValues: {
            situacion: "",
            comentario: ""
        },
        validationSchema: validationSchemasCierreGestionDefenza(limites.pesado),
        onSubmit: async (data) => {
            if (data.situacion != "rechazo" && !procesoSeleccionado) handleShowModalInfo(1)
            else if (data.situacion === "conPago" && !totalesPagados) handleShowModalInfo(2)
            else {
                let dataResult = { ...data };

                dataResult.idCaso = llaves.idCaso;
                dataResult.idOrganizacion = llaves.idOrgCaso;
                dataResult.idUsuario = llaves.idUsuario;

                if (data.situacion === "conPago") {
                    dataResult.cierreConPago = 1;
                    dataResult.cierreSinPago = 0;
                    dataResult.rechazoCoberturaRC = 0;
                } else if (data.situacion === "sinPago") {
                    dataResult.cierreConPago = 0;
                    dataResult.cierreSinPago = 1;
                    dataResult.rechazoCoberturaRC = 0;
                } else {
                    dataResult.cierreConPago = 0;
                    dataResult.cierreSinPago = 0;
                    dataResult.rechazoCoberturaRC = 1;
                }
                dataResult.idProcesoSeleccionado = procesoSeleccionado?.idInstancia;
                if (data.file) {
                    if (esArchivoGrande(data.file, limites.liviano)) {
                        try {
                            setLoading(true);
                            let archivoRef;
                            if (archivoSubidoRef.current.file === data.file) {
                                archivoRef = archivoSubidoRef.current;
                            } else {
                                archivoRef = await subirArchivoGrandeS3(data.file);
                                archivoSubidoRef.current = { file: data.file, ...archivoRef };
                            }
                            dataResult = { ...dataResult, "filename": data.file.name, "mimetype": data.file.type, "s3Bucket": archivoRef.s3Bucket, "s3Key": archivoRef.s3Key };
                            cierreGestionDefenza(dataResult);
                        } catch (err) {
                            setLoading(false);
                            setResponseData({ code: -1, object: null, message: err.message });
                            setShowToast(true);
                        }
                    } else {
                        getBase64(data.file).then((base64data) => {
                            const fileData = base64data.split(',')[1]
                            dataResult = { ...dataResult, "filename": data.file.name, "mimetype": data.file.type, "base64data": fileData };

                            cierreGestionDefenza(dataResult);
                        })
                    }
                } else {
                    setHandleDataSubmit(dataResult);
                    setShowModalConfirm(true);
                }
            }
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showCierreGestion} onHide={handleCloseModal} size='xl'>
                <Form onSubmit={formik.handleSubmit}>
                    <Card>
                        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            {cfg_form && cfg_form["modalgestioncierre-title"]}
                        </Card.Header>

                        <Card.Body>
                            <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className="label is_required">
                                            {cfg_form && cfg_form["modalgestioncierre-lbl-situacion"]}
                                        </Form.Label>
                                    </Col>
                                    <Col md='2'>
                                        <Form.Check
                                            type="radio"
                                            name="situacion"
                                            value="conPago"
                                            checked={formik.values.situacion === 'conPago'}
                                            disabled={!validateSituacion.tieneProcesoCerrado}
                                            label={cfg_form && cfg_form["modalgestioncierre-chk-conpago"]}
                                            onChange={(e) => { formik.handleChange(e); setSituacionSelect(e.target.value) }}
                                        />
                                    </Col>
                                    <Col md='2'>
                                        <Form.Check
                                            type="radio"
                                            name="situacion"
                                            value="sinPago"
                                            checked={formik.values.situacion === 'sinPago'}
                                            disabled={!validateSituacion.tieneProcesoCerrado}
                                            label={cfg_form && cfg_form["modalgestioncierre-chk-sinpago"]}
                                            onChange={(e) => { formik.handleChange(e); setSituacionSelect(e.target.value) }}
                                        />
                                    </Col>
                                    <Col md='3'>
                                        <Form.Check
                                            type="radio"
                                            name="situacion"
                                            value="rechazo"
                                            checked={formik.values.situacion === 'rechazo'}
                                            disabled={validateSituacion.tieneProcesoCierreAplicado}
                                            label={cfg_form && cfg_form["modalgestioncierre-chk-rechazorc"]}
                                            onChange={(e) => { formik.handleChange(e); setSituacionSelect(e.target.value) }}
                                        />
                                    </Col>
                                    <Col md='2'>
                                        {formik.errors.situacion && formik.touched.situacion &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.situacion}
                                            </Form.Text>
                                        }
                                    </Col>

                                    <Col md='6'>
                                        <Form.Label className='label is_required mt-2'>
                                            {cfg_form && cfg_form["modalgestioncierre-input-comentario"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            as='textarea'
                                            className='mb-2'
                                            rows={2}
                                            name="comentario"
                                            value={formik.values.comentario}
                                            onChange={e => formik.handleChange(e)}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.comentario && formik.touched.comentario &&
                                            <Form.Text style={{ color: 'red' }}>
                                                {formik.errors.comentario}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='6'>
                                        <Form.Label className='label mt-2'>
                                            {cfg_form && cfg_form["modalgestioncierre-inputfile-informe"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            type="file"
                                            name='file'
                                            ref={fileRef}
                                            onChange={handleFileChange}
                                            onBlur={formik.handleBlur}>
                                        </Form.Control>
                                        {formik.errors.file && formik.touched.file &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.file}
                                            </Form.Text>
                                        }
                                    </Col>
                                </Row>
                            </Container>

                            <Procesos
                                cfg_form={cfg_form}
                                situacion={situacionSelect}
                                setTotalesPagados={setTotalesPagados}
                                setValidateSituacion={setValidateSituacion}
                                loadProcesos={loadProcesos}
                                setProcesoSeleccionado={setProcesoSeleccionado}
                            />
                        </Card.Body>
                        {showToast && 
                            <Mensajes
                                showToast={showToast}
                                handleCloseToast={handleCloseToast}
                                delay={5000}
                                responseData={responseData}
                            ></Mensajes>
                        }
                        <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                            <Button className='w-auto' variant='outline-info' onClick={handleCloseModal}>
                                {cfg_form && cfg_form["modalgestioncierre-btn-volver"]}
                            </Button>
                            <Button type="submit" className='w-auto' variant='danger' disabled={loading}>
                                {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                                {cfg_form && cfg_form["modalgestioncierre-btn-cierre"]}
                            </Button>
                        </Card.Footer>
                    </Card>
                </Form>
            </Modal>

            <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Información
                    </Card.Header>

                    <Card.Body>
                        {glosaModalInfo}
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalInfo(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showModalConfirm} onHide={() => setShowModalConfirm(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>

                    <Card.Body>
                        No se ha seleccionado documento de informe final. ¿Desea continuar sin subir informe de cierre?
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalConfirm(false)}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={() => cierreGestionDefenza()}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>

                    <Card.Body>
                        {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                `}
            </style>
        </Fragment >
    )
}

export default CierreGestionDefenzaModal